/* eslint-disable */

import {
  Avatar,
  Badge,
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Icon,
  Stack,
  Tag,
  Box,
  Image,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
// Custom components
import { MdChevronRight, MdChevronLeft } from 'react-icons/md';
import * as React from 'react';
// Assets
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

import {
  PaginationState,
  createColumnHelper,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { AcceptInviteButtons } from './AcceptInviteButtons';

type RowObj = {
  companyName: string;
  portalId: string;
  email: string;
  dateConnected: string;
  status: string;
  userAction: string;
  invitationId: string;
  type: string;
  logoUrl?: string;
};

export const ConnectedPartnerTable = (props: {
  tableData: any;
  onInvitationResponse?: (invitationId: string, response: string) => void;
  onPartnerDisconnect?: (partnerId: string) => void;
  onCancelInvite?: (invitationId: string) => void;
  onInvitePartner?: (partnerId: string) => void;
  disableAdminPartnerActions?: boolean;
}) => {
  const {
    tableData,
    onInvitationResponse,
    onPartnerDisconnect,
    onCancelInvite,
    onInvitePartner,
    disableAdminPartnerActions = false,
  } = props;
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>(
    [],
  );
  let defaultData = tableData;
  const [globalFilter, setGlobalFilter] = React.useState('');
  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor(
      (row) => ({
        portalId: row.portalId,
        companyName: row.companyName,
        logoUrl: row.logoUrl,
      }),
      {
        id: 'companyName',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
          >
            COMPANY NAME
          </Text>
        ),
        cell: (info: any) => {
          const { companyName, logoUrl } = info.getValue();
          return (
            <Flex align="center" gap="12px">
              {logoUrl && (
                <Box
                  w="32px"
                  h="32px"
                  borderRadius="8px"
                  bg="gray.100"
                  overflow="hidden"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Image
                    src={logoUrl}
                    alt={companyName}
                    w="100%"
                    h="100%"
                    objectFit="contain"
                    fallbackSrc="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNiA4QzE4LjIwOTEgOCAyMCAxMC4yMDkxIDIwIDEyQzIwIDEzLjc5MDkgMTguMjA5MSAxNiAxNiAxNkMxMy43OTA5IDE2IDEyIDEzLjc5MDkgMTIgMTJDMTIgMTAuMjA5MSAxMy43OTA5IDggMTYgOFoiIGZpbGw9IiM5Q0EzQUYiLz4KPHBhdGggZD0iTTI0IDI0QzI0IDI2LjIwOTEgMjIuMjA5MSAyOCAyMCAyOEgxMkM5Ljc5MDkgMjggOCAyNi4yMDkxIDggMjRWMjBDOCAxNy43OTA5IDkuNzkwOSAxNiAxMiAxNkgyMEMyMi4yMDkxIDE2IDI0IDE3Ljc5MDkgMjQgMjBWMjRaIiBmaWxsPSIjOUNBM0FGIi8+Cjwvc3ZnPgo="
                  />
                </Box>
              )}
              <Text
                color={textColor}
                fontSize="md"
                fontWeight="500"
                maxW="200px"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {companyName}
              </Text>
            </Flex>
          );
        },
      },
    ),

    columnHelper.accessor('status', {
      id: 'status',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          textAlign="center"
        >
          STATUS
        </Text>
      ),
      cell: (info) => <StatusTag status={info.getValue()} />,
    }),
    columnHelper.accessor('dateConnected', {
      id: 'dateConnected',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          PARTNERSHIP DATE
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          <Text color={textColor} fontSize="md" fontWeight="500">
            {info.getValue()
              ? new Date(info.getValue()).toLocaleString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                })
              : '-'}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor(
      // Function that accesses multiple fields and returns a custom object
      (row) => ({
        invitationId: row.invitationId,
        status: row.status,
        type: row.type,
        partnerId: row.portalId,
      }),
      {
        id: 'userActions',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
          >
            ACTIONS
          </Text>
        ),
        cell: (info) => {
          // The getValue() now returns the object with all needed properties
          const { invitationId, type, status, partnerId } = info.getValue();

          return (
            <AcceptInviteButtons
              invitationId={invitationId}
              partnerId={partnerId}
              status={status}
              onInvitationResponse={onInvitationResponse}
              onPartnerDisconnect={onPartnerDisconnect}
              onCancelInvite={onCancelInvite}
              onInvitePartner={onInvitePartner}
              disableAdminPartnerActions={disableAdminPartnerActions}
            />
          );
        },
      },
    ),
  ];
  const [data, setData] = React.useState(() => [...defaultData]);
  const [{ pageIndex, pageSize }, setPagination] =
    React.useState<PaginationState>({
      pageIndex: 0,
      pageSize: 6,
    });

  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize],
  );

  const table = useReactTable({
    data,
    columns,
    state: {
      columnFilters,
      globalFilter,
      pagination,
    },
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  });
  const createPages = (count: number) => {
    let arrPageCount = [];

    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }

    return arrPageCount;
  };

  React.useEffect(() => {
    if (table.getState().columnFilters[0]?.id === 'fullName') {
      if (table.getState().sorting[0]?.id !== 'fullName') {
        table.setSorting([{ id: 'fullName', desc: false }]);
      }
    }
  }, [table.getState().columnFilters[0]?.id]);

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: 'scroll' }}>
      {tableData.length === 0 ? (
        <Flex
          direction="column"
          align="center"
          justify="center"
          py={12}
          px={6}
          textAlign="center"
        >
          <Text fontSize="lg" fontWeight="600" color={textColor} mb={2}>
            Ready to grow your ecosystem?
          </Text>
          <Text fontSize="md" color="gray.500" maxW="400px" lineHeight="1.6">
            Connect your first partner to start discovering overlaps and driving
            revenue with cocorev.
          </Text>
        </Flex>
      ) : (
        <>
          <Table variant="simple" color="gray.500" mb="24px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        pe="10px"
                        borderColor={borderColor}
                        key={header.id}
                        colSpan={header.colSpan}
                      >
                        {header.isPlaceholder ? null : (
                          <Flex
                            {...{
                              className: header.column.getCanSort()
                                ? 'cursor-pointer select-none'
                                : '',
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                            justify="space-between"
                            align="center"
                            fontSize={{ sm: '10px', lg: '12px' }}
                            color="gray.400"
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                            {{
                              asc: '',
                              desc: '',
                            }[header.column.getIsSorted() as string] ?? null}
                          </Flex>
                        )}
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {table.getRowModel().rows.map((row) => {
                return (
                  <Tr
                    px="20px"
                    key={row.id}
                    _hover={{
                      bg: useColorModeValue('gray.50', 'whiteAlpha.50'),
                      cursor: 'pointer',
                    }}
                    transition="all 0.2s"
                  >
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <Td
                          key={cell.id}
                          fontSize={{ sm: '14px' }}
                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                          borderColor={borderColor}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext(),
                          )}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </>
      )}
      {tableData.length > 0 && (
        <Flex
          w="100%"
          justify="space-between"
          px="20px"
          pt="10px"
          pb="5px"
          align="center"
        >
          {/* SET ROW NUMBER */}
          <Text
            fontSize="sm"
            color="gray.500"
            fontWeight="normal"
            mb={{ sm: '24px', md: '0px' }}
          >
            Showing {pageSize * pageIndex + 1} to{' '}
            {pageSize * (pageIndex + 1) <= tableData.length
              ? pageSize * (pageIndex + 1)
              : tableData.length}{' '}
            of {tableData.length} entries
          </Text>
          {/* PAGINATION BUTTONS */}
          <div className="flex items-center gap-2">
            <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
              <Button
                variant="no-effects"
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
                transition="all .5s ease"
                w="40px"
                h="40px"
                borderRadius="50%"
                bg="transparent"
                border="1px solid"
                borderColor={useColorModeValue('gray.200', 'white')}
                display={
                  pageSize === 5
                    ? 'none'
                    : table.getCanPreviousPage()
                    ? 'flex'
                    : 'none'
                }
                _hover={{
                  bg: 'whiteAlpha.100',
                  opacity: '0.7',
                }}
              >
                <Icon as={MdChevronLeft} w="16px" h="16px" color={textColor} />
              </Button>
              {createPages(table.getPageCount()).map((pageNumber, index) => {
                return (
                  <Button
                    variant="no-effects"
                    transition="all .5s ease"
                    onClick={() => table.setPageIndex(pageNumber - 1)}
                    w="40px"
                    h="40px"
                    borderRadius="50%"
                    bg={
                      pageNumber === pageIndex + 1 ? 'brand.50' : 'transparent'
                    }
                    border={
                      pageNumber === pageIndex + 1
                        ? 'none'
                        : '1px solid lightgray'
                    }
                    _hover={
                      pageNumber === pageIndex + 1
                        ? {
                            opacity: '0.7',
                          }
                        : {
                            bg: 'whiteAlpha.100',
                          }
                    }
                    key={index}
                  >
                    <Text
                      fontSize="sm"
                      color={pageNumber === pageIndex + 1 ? 'black' : textColor}
                    >
                      {pageNumber}
                    </Text>
                  </Button>
                );
              })}
              <Button
                variant="no-effects"
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
                transition="all .5s ease"
                w="40px"
                h="40px"
                borderRadius="50%"
                bg="transparent"
                border="1px solid"
                borderColor={useColorModeValue('gray.200', 'white')}
                display={
                  pageSize === 5
                    ? 'none'
                    : table.getCanNextPage()
                    ? 'flex'
                    : 'none'
                }
                _hover={{
                  bg: 'whiteAlpha.100',
                  opacity: '0.7',
                }}
              >
                <Icon as={MdChevronRight} w="16px" h="16px" color={textColor} />
              </Button>
            </Stack>
          </div>
        </Flex>
      )}
    </Flex>
  );
};

// A debounced input react component
function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <SearchBar
      {...props}
      value={value}
      onChange={(e: any) => setValue(e.target.value)}
      h="44px"
      w={{ lg: '390px' }}
      borderRadius="16px"
    />
  );
}

// StatusTag component for status column
const StatusTag = ({ status }: { status: string }) => {
  let colorScheme = {
    bg: 'gray.100',
    color: 'gray.500',
  };
  let text = status;
  switch (status?.toLowerCase()) {
    case 'accepted':
      colorScheme = { bg: 'green.100', color: 'green.600' };
      text = 'Connected';
      break;
    case 'disconnected':
      colorScheme = { bg: 'gray.100', color: 'gray.400' };
      text = 'Disconnected';
      break;
    case 'pending':
      colorScheme = { bg: 'yellow.100', color: 'yellow.700' };
      text = 'Pending';
      break;
    case 'requested':
      colorScheme = { bg: 'purple.100', color: 'purple.600' };
      text = 'Requested';
      break;
    default:
      colorScheme = { bg: 'gray.100', color: 'gray.500' };
      text = status;
  }
  return (
    <Tag
      w="fit-content"
      maxW="100%"
      whiteSpace="nowrap"
      h="30px"
      mb="6px"
      me="6px"
      px="14px"
      borderRadius="15px"
      bg={colorScheme.bg}
      display="flex"
      alignItems="center"
      borderWidth={0}
    >
      <Text color={colorScheme.color} fontSize="14px" fontWeight="700" lineHeight="1">
        {text}
      </Text>
    </Tag>
  );
};
